import { getByPath, setByPath } from '../lib/path';
import { FieldConfig } from './types';

export function mapValuesForWrite<TCtx>(
  controls: FieldConfig<TCtx>[],
  values: Record<string, any>,
  ctx: TCtx,
  includeUnchangedFields: boolean = false
): TCtx {
  let out: TCtx = includeUnchangedFields ? structuredClone(ctx) : ({} as TCtx);

  for (const c of controls) {
    if (!c.write) continue;

    // Получаем значение: сначала из измененных значений, потом из контекста
    let v = values[c.id];
    if (v === undefined) {
      // Если значения нет в state.values, читаем из контекста
      if (typeof c.read === 'function') {
        v = c.read(ctx);
      } else if (typeof c.read === 'string') {
        v = getByPath(ctx, c.read);
      }
    }

    if (typeof c.write === 'function') {
      out = c.write(v, out);
    } else {
      const tv = c.write.transform ? c.write.transform(v, out) : v;
      if (tv === undefined) continue;
      setByPath(out as Record<string, unknown>, c.write.path, tv);
    }
  }

  return out;
}
